import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { take, tap } from 'rxjs/operators';
import { NativeClientService } from '@shared/services/native-client.service';
import { AuthService } from '../../services/auth.service';
import { MessengerService } from '../../services/messenger/messenger.service';
import { SessionStorageService } from '../../services/session-storage.service';
import { UserInfoService } from '../../services/user-info.service';
import { UserProfileService } from '../../services/user-profile.service';
import { OrchestratorService } from '@core/services/orchestrator.service';
import {
  authenticated,
  autoLogin,
  clearToken,
  fullAuthenticated,
  logoutOAuth,
  restoreSession,
} from '../actions/session-auth.actions';

/**
 * !!!! DO NOT REMOVE CSRF Token from session storage !!!!
 *
 * CSRF Token in session storage is not used by portal itself,
 * but it is needed by other applications, for example messenger.
 */
const SESSION_STORAGE_TOKEN_KEY = 'X_CSRF_TOKEN';

@Injectable()
export class SessionAuthEffects {
  autoLogin$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(autoLogin),
        tap(() => {
          this.authService.connectOAuth(true);
        }),
      ),
    { dispatch: false },
  );

  authenticated$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(authenticated),
        tap(({ token }) => {
          this.sessionStorageService.set(SESSION_STORAGE_TOKEN_KEY, token);
          if (token) {
            this.userInfoService.fetchData();
            //TODO VANESSA comment in again
            // this.logService.initDisablingLogging();
            this.userProfileService.fetchData();

            if (!this.nativeClientService.isNative) {
              this.router.navigate(['/dashboard']);
            }
          }
        }),
      ),
    { dispatch: false },
  );

  restoreSession$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(restoreSession),
        tap(({ token }) => {
          this.sessionStorageService.set(SESSION_STORAGE_TOKEN_KEY, token);
          if (token) {
            // fetch all data for the user and their profile
            this.userInfoService.fetchData();
            this.userProfileService.fetchData();
          }
        }),
      ),
    { dispatch: false },
  );

  fullAuthenticated$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fullAuthenticated),
        tap(() => {
          this.messenger.startMessenger();

          // If user was fully verified and onboarded,
          // but did not get the FULL onboarded level, then update it accordingly
          this.orchestratorService
            .updateUserProfile()
            .pipe(take(1))
            .subscribe();
        }),
      ),
    { dispatch: false },
  );

  clearToken$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(clearToken, logoutOAuth),
        tap(() => {
          this.sessionStorageService.clear();
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private sessionStorageService: SessionStorageService,
    private authService: AuthService,
    private userInfoService: UserInfoService,
    private userProfileService: UserProfileService,
    private messenger: MessengerService,
    private router: Router,
    private nativeClientService: NativeClientService,
    private orchestratorService: OrchestratorService,
  ) {}
}
